export const typography = {
  h1: {
    fontSize: ['3xl', '3xl', '4xl', '4xl', '4xl'],
    fontWeight: 'bold',
  },
  h2: {
    fontSize: ['2xl', '2xl', '3xl', '3xl', '3xl'],
    fontWeight: 'semibold',
  },
  h3: {
    fontSize: ['xl', 'xl', '2xl', '2xl', '2xl'],
    fontWeight: 'semibold',
  },
  h4: {
    fontSize: ['lg', 'lg', 'xl', 'xl', 'xl'],
    fontWeight: 'medium',
  },
  h5: {
    fontSize: ['md', 'md', 'lg', 'lg', 'lg'],
    fontWeight: 'medium',
  },
  p: {
    fontSize: ['sm', 'sm', 'md', 'md', 'md'],
    fontWeight: 'normal',
  },
  small: {
    fontSize: ['xs', 'xs', 'sm'],
    fontWeight: 'normal',
  },
};
